import { makeStyles } from "@mui/styles";
import image from "../assets/images/ErorrLogo.svg";

const useStyles = makeStyles({
  notFound: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(90vh - var(--topSpace))",
    "& img": {
      maxWidth: "70%",
      mixBlendMode: "darken",
    },
    "& h2": {
      marginTop: "12px",
      fontSize: "28px",
      fontWeight: 700,
      color: "#1a1a1a",
    },
  },
});

const PageNotFound = () => {
  const classes = useStyles();
  return (
    <div className={classes.notFound} style={{ height: "100vh" }}>
      <img loading="lazy" src={image} alt="404" />
      <h2>404 Not Found</h2>
    </div>
  );
};

export default PageNotFound;
